import { OpenInNewOutlined } from '@mui/icons-material'
import { IconButton } from '@mui/material'

import { useOpenDiagnostics } from 'features/yieldbirdWrapperAgent/hooks/useOpenDiagnostics'

import type { Report } from 'features/yieldbirdWrapperAgent/api/types'
import type { MouseEvent } from 'react'

const MIDDLE_MOUSE_BUTTON: MouseEvent<HTMLButtonElement>['button'] = 1

type Props = {
  jobId: Report['jobId']
}

export const OpenDiagnosticsButton = ({ jobId }: Props): React.JSX.Element => {
  const { open } = useOpenDiagnostics()

  return (
    <IconButton
      onAuxClick={(event: MouseEvent<HTMLButtonElement>): void => {
        if (event.button === MIDDLE_MOUSE_BUTTON) {
          void open(jobId)
        }
      }}
      onClick={() => void open(jobId)}
      size='small'
    >
      <OpenInNewOutlined />
    </IconButton>
  )
}
